import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from '../models/user';
import { ApplicationService } from '../services/application.service';
import { UserService } from '../services/user/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl, Validators } from '@angular/forms';
import { SaldoCutiRequest } from '../models/saldo-cuti-request';

@Component({
  selector: 'app-hak-cuti-dialog',
  templateUrl: './hak-cuti-dialog.component.html',
  styleUrls: ['./hak-cuti-dialog.component.css']
})
export class HakCutiDialogComponent implements OnInit {
  hakCutiN = new FormControl(0, [Validators.required]);
  hakCutiN1 = new FormControl(0, [Validators.required]);
  isLoading = false;
  form: any = {
    hakCutiN: 0,
    hakCutiN1: 0,
  }

  curYear = new Date().getFullYear();
  yearN1 = this.curYear - 1;

  constructor(
    public matDialogRef: MatDialogRef<HakCutiDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: User,
    private applicationService: ApplicationService,
    private userService: UserService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.hakCutiN.setValue(this.data.hakCuti || 0);
    this.hakCutiN1.setValue(this.data.hakCutiN1 || 0);
  }

  onSubmit(): void {
    this.isLoading = true;
    const request: SaldoCutiRequest = {
      userId: this.data.id!,
      hakCutiN: this.hakCutiN.value,
      hakCutiN1: this.hakCutiN1.value,
    };

    this.userService.updateHakCuti(request).subscribe((response) => {
      this.showSnackBar('User berhasil diperbaharui');
      this.matDialogRef.close(true);
      this.isLoading = false;
    });
  }

  showSnackBar(message: string) {
    this.snackBar.open(message, 'OK', {
      duration: 3000,
    });
  }

  getErrorMessage(formControl: FormControl) {
    if (formControl.hasError('required')) {
      return 'Harus diisi';
    }

    return '';
  }

}
